module.exports = __webpack_public_path__ + "img/ic_survey_disabled.bbb407d4.svg";